import React from "react";
import { useTranslation } from "react-i18next";

// Small build badge so QA can verify a deployment reached the browser (cache check).
// Build time comes from the JS bundle; the label comes from translation.json.
// Shown on non-prod builds, or on prod when the URL has ?showBuild=true.
const isVisible = () => {
  try {
    if (window.location.search.includes("showBuild=true")) {
      sessionStorage.setItem("showBuild", "true");
    }
    return (
      process.env.REACT_APP_BUILD !== "prod" ||
      sessionStorage.getItem("showBuild") === "true"
    );
  } catch (e) {
    return process.env.REACT_APP_BUILD !== "prod";
  }
};

const style = {
  position: "fixed",
  left: 8,
  bottom: 8,
  zIndex: 9999,
  padding: "2px 8px",
  fontSize: 11,
  color: "#fff",
  background: "rgba(0, 0, 0, 0.6)",
  borderRadius: 4,
  pointerEvents: "none",
};

const BuildInfo = () => {
  const { t } = useTranslation(undefined, { useSuspense: false });
  if (!isVisible()) return null;

  const builtAt = new Date(process.env.REACT_APP_BUILD_TIME).toLocaleString();
  return (
    <div style={style} data-testid="build-info">
      {t("BUILD_LABEL")}: {builtAt}
    </div>
  );
};

export default BuildInfo;
